export class SectionItem{
     id:number;
     type:string;
     priority:number;
     display_mode:string;
     body:Map<string,any>=new Map<string, any>();
}